import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";   // ✅ Import toast

export default function VerifyOtp() {
  const qs = new URLSearchParams(useLocation().search);
  const email = qs.get("email");
  const name = qs.get("name");
  const category = qs.get("category");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleVerify = async () => {
    if (!otp) {
      toast.error("Enter OTP"); // ❌ error toast
      return;
    }
    setLoading(true);
    try {
      const res = await fetch("https://globisun-app.onrender.com/api/auth/verify-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp }),
      });
      const data = await res.json();
      setLoading(false);

      if (!res.ok) {
        toast.error(data.msg || "Invalid OTP"); // ❌ error toast
        return;
      }

      toast.success("OTP verified 🎉"); // ✅ success toast
      navigate(`/complete-registration?email=${email}&name=${name}&category=${category}`);
    } catch (err) {
      console.error(err);
      toast.error("Error verifying OTP ❌"); // ❌ error toast
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="register-box">
        <h2>Verify OTP</h2>
        <p>
          OTP sent to <strong>{email}</strong>
        </p>
        <input
          type="text"
          placeholder="Enter OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
        />
        <button onClick={handleVerify} disabled={loading}>
          {loading ? "Verifying..." : "Verify OTP"}
        </button>
      </div>
    </div>
  );
}
